import PropTypes from "prop-types";
import React from "react";
import Modal from "react-awesome-modal";
import { useSelector, useDispatch } from "react-redux";
import { closeConfirmDialog } from "./Store/actions";
import { selectConfirmDialog } from "./Store/selectors";
import { ButtonField } from "../Fields/ButtonField";
import "./ConfirmDialog.css"; // #region HOOK

/**
 * Représente une boîte de dialogue avec 2 boutons Oui/Non
 * @class
 * @category Dialogs
 * @param {ConfirmDialog.propTypes} props Les propriétés du composant
 */

function ConfirmDialog(props) {
  // Récupération des props
  var buttonColor = props.buttonColor,
      textButtonColor = props.textButtonColor,
      textColor = props.textColor; // Récupération du state global

  var confirmDialog = useSelector(function (state) {
    return selectConfirmDialog(state);
  }); // Récupération du dispatch

  var dispatch = useDispatch();
  /**
   * Fonction appelée lors de la validation de la boîte de dialogue
   */

  var onValidInternal = function onValidInternal() {
    // Exécution de la fonction de validation
    if (confirmDialog.onValid) {
      confirmDialog.onValid();
    } // Fermeture de la boîte de dialogue


    dispatch(closeConfirmDialog());
  };
  /**
   * Fonction appelée lors de l'annulation de la boîte de dialogue
   */


  var onCancelInternal = function onCancelInternal() {
    // Exécution de la fonction d'annulation
    if (confirmDialog.onCancel) {
      confirmDialog.onCancel();
    } // Fermeture de la boîte de dialogue


    dispatch(closeConfirmDialog());
  }; // Interface


  return /*#__PURE__*/React.createElement(Modal, {
    visible: confirmDialog.open,
    effect: "fadeInUp",
    onClickAway: onCancelInternal,
    width: "380px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ConfirmDialog-Container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ConfirmDialog-Message",
    style: {
      color: textColor
    }
  }, confirmDialog.message), /*#__PURE__*/React.createElement("div", {
    className: "ConfirmDialog-ButtonContainer"
  }, /*#__PURE__*/React.createElement(ButtonField, {
    tooltip: "Non",
    icon: "times",
    onClick: onCancelInternal,
    backgroundColor: buttonColor,
    iconColor: textButtonColor
  }), /*#__PURE__*/React.createElement("div", {
    className: "ConfirmDialog-ButtonConfirm"
  }, /*#__PURE__*/React.createElement(ButtonField, {
    tooltip: "Oui",
    icon: "check",
    onClick: onValidInternal,
    backgroundColor: buttonColor,
    iconColor: textButtonColor
  })))));
} // #endregion
// #region PROPRIETES

/**
  * Type des propriétés
  * @typedef {Object} ConfirmDialog.propTypes
  * @property {string} [textColor=#000] Couleur du texte du message
  * @property {string} [textButtonColor=#fff] Couleur du texte du bouton
  * @property {string} [buttonColor=#000] Couleur du bouton
  */


ConfirmDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  textColor: PropTypes.string,
  textButtonColor: PropTypes.string,
  buttonColor: PropTypes.string
} : {};
/*
  Valeurs par défaut des propriétés
*/

ConfirmDialog.defaultProps = {
  textColor: "#000",
  textButtonColor: "#fff",
  buttonColor: "#000"
}; // #endregion

export { ConfirmDialog };